import React, { Component } from 'react';
import { connect } from 'react-redux';
import YTplayer from './YTplayer';

export default class VideoIOS extends Component {
    render () {
        return (
            <div className="ios_video_frame replay_item__map">
                <YTplayer autoplay={false} ytId={this.props.ytId}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/videoIOS.js